export const AUTH_STORAGE_NAME = 'userAuth';
export const AUTH_COOKIES = 'joinnusClient';
export const TOKEN_COOKIE = 'joinnus2'
export default {};
